import { render } from "./about.vue?vue&type=template&id=e0c6d7bc&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=e0c6d7bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e0c6d7bc"

export default script